import { render, staticRenderFns } from "./table-modal.vue?vue&type=template&id=c35031f0&"
import script from "./table-modal.vue?vue&type=script&lang=js&"
export * from "./table-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports